<button
  class="rounded-xl border border-neutral-300 w-full py-4 px-3 bg-neutral-50 cursor-pointer h-full text-start flex items-center"
  (click)="toggle(!checked)"
  matRipple
  matRippleColor="rgba(0, 0, 0, 0.1)"
  type="button"
>
  <div class="flex gap-x-3 items-center justify-between w-full">
    <div>
      <p class="text-base font-semibold">{{ label }}</p>
      <p class="text-xs">{{ description }}</p>
    </div>
    <div>
      <mat-checkbox
        (click)="$event.stopPropagation()"
        ctrColorCheckbox
        [checked]="checked"
        (change)="toggle($event.checked)"
      ></mat-checkbox>
    </div>
  </div>
</button>
